@if (!config.customModal) {
  <confirmation-modal
    [config]="config"
    [context]="context"
    (confirm)="confirm.emit()"
    (cancel)="cancel.emit()"
  ></confirmation-modal>
} @else {
  <article class="modal custom--modal modal--small" @fade>
    <section class="modal__body t-data">
      <div class="u-flex u-column u-alignCenter custom-modal-body">
        @if (config.customModal.imgLink) {
          <img
            class="top-icon"
            data-test-id="confirmationCustomModalImg"
            [src]="config.customModal.imgLink"
          />
        }
        @if (config.customModal.header) {
          <h6
            class="t-bold text-align-center custom-modal-header"
            data-test-id="confirmationCustomModalHeader"
            [innerHtml]="config.customModal.header"
          ></h6>
        }
        @if (config.customModal.subHeader) {
          <p
            [innerHtml]="config.customModal.subHeader"
            data-test-id="confirmationCustomModalSubHeader"
            class="t-data text-align-center custom-modal-subheader"
          ></p>
        }
        @if (config.customModal.btn) {
          <zip-button
            [config]="config.customModal.btn"
            (zipButtonClicked)="onButtonClicked($event, config.customModal.btn)"
            data-test-id="confirmationCustomModalButton"
            class="custom-modal-button"
          ></zip-button>
        }
        @if (config.customModal.footerDescription) {
          <p
            class="t-data text-align-center"
            data-test-id="confirmationCustomModalFooterDescription"
            [innerHtml]="config.customModal.footerDescription"
          ></p>
        }
        @if (config.customModal.footerOptions) {
          <div class="u-flex">
            @for (
              link of config.customModal.footerOptions;
              track link;
              let i = $index
            ) {
              <a
                [href]="link.link"
                [innerHtml]="link.label"
                [attr.data-test-id]="'confirmationCustomModalFooterLink_' + i"
                class="t-link custom-modal-link"
              >
              </a>
              @if (link.icon) {
                <icon
                  class="icon"
                  [name]="link.icon.name"
                  [attr.data-test-id]="'confirmationCustomModalFooterIcon_' + i"
                  [config]="link.icon"
                ></icon>
              }
            }
          </div>
        }
      </div>
    </section>
  </article>
}

<ng-template #customModal>
  <article class="modal custom--modal modal--small" @fade>
    <section class="modal__body t-data">
      <div class="u-flex u-column u-alignCenter custom-modal-body">
        @if (config.customModal.imgLink) {
          <img
            class="top-icon"
            data-test-id="confirmationCustomModalImg"
            [src]="config.customModal.imgLink"
          />
        }

        @if (config.customModal.header) {
          <h6
            class="t-bold text-align-center custom-modal-header"
            data-test-id="confirmationCustomModalHeader"
            [innerHtml]="config.customModal.header"
          ></h6>
        }

        @if (config.customModal.subHeader) {
          <p
            [innerHtml]="config.customModal.subHeader"
            data-test-id="confirmationCustomModalSubHeader"
            class="t-data text-align-center custom-modal-subheader"
          ></p>
        }

        @if (config.customModal.btn) {
          <zip-button
            [config]="config.customModal.btn"
            (zipButtonClicked)="onButtonClicked($event, config.customModal.btn)"
            data-test-id="confirmationCustomModalButton"
            class="custom-modal-button"
          ></zip-button>
        }

        @if (config.customModal.footerDescription) {
          <p
            class="t-data text-align-center"
            data-test-id="confirmationCustomModalFooterDescription"
            [innerHtml]="config.customModal.footerDescription"
          ></p>
        }

        @if (config.customModal.footerOptions) {
          <div class="u-flex">
            @for (
              link of config.customModal.footerOptions;
              track link;
              let i = $index
            ) {
              <a
                [href]="link.link"
                [innerHtml]="link.label"
                [attr.data-test-id]="'confirmationCustomModalFooterLink_' + i"
                class="t-link custom-modal-link"
              >
              </a>
              @if (link.icon) {
                <icon
                  class="icon"
                  [name]="link.icon.name"
                  [attr.data-test-id]="'confirmationCustomModalFooterIcon_' + i"
                  [config]="link.icon"
                ></icon>
              }
            }
          </div>
        }
      </div>
    </section>
  </article>
</ng-template>
